import { baseQuery } from '../baseQuery';

type TaskCountResponse = [
  {
    ID: number;
    label: string;
    parent_ID: number | null;
    count: number;
    overdue?: number;
    withinOneHour?: number;
    complete?: number;
  },
];

export const getTasksCount = async () => {
  const { data } = await baseQuery('tasks/count');

  return data as TaskCountResponse;
};
